import { z } from 'zod';
export const meetingBodyRoleCreateSchema = z.object({
    name: z.string('Name is required').min(1, 'Name is required'),
    isMinutesAdmin: z.boolean().optional(),
    isMeetingAdmin: z.boolean().optional(),
    isAgendaAdmin: z.boolean().optional(),
    isLegislativeItemsAdmin: z.boolean().optional(),
    isBoardAdmin: z.boolean().optional(),
    isBoardViewer: z.boolean().optional(),
    isGlobalViewer: z.boolean().optional(),
});
export const meetingBodyRoleUpdateSchema = meetingBodyRoleCreateSchema.partial();
